import { ObjectFieldTemplateProps } from "@rjsf/utils";
import useUpdateSectionAction from "../../actions/updateSection/useUpdateSectionAction";

function YouWillProbablyLikeTemplate(
  props: ObjectFieldTemplateProps,
  func: any
) {
  const { actionTemplate } = useUpdateSectionAction();
  return (
    <>
      <div className="cms-section">
        <div className="h3">
          {props.title} {actionTemplate}
        </div>
        <div className="section row">
          <div className="col-12">
            <div className="property-wrapper">
              {func("you_will_probably_like", props)?.content}
            </div>
          </div>
          <div className="col-12">
            <div className="property-wrapper">
              {func("bear_in_mind", props)?.content}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default YouWillProbablyLikeTemplate;
